import { closestCorners, pointerWithin } from '@dnd-kit/core';

export const customCollisionDetectionAlgorithm = (args) =>
  pointerWithin(args)?.length ? pointerWithin(args) : closestCorners(args);
